import React, { useEffect, useState } from 'react'

import { Button, DatePicker, notification } from 'antd'

import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import moment from 'moment'

// Component
import MainHeader from '../components/MainHeader'
import Loader from '../components/Loader'

import { clearNotification, getAllNotification } from '../redux/actions/notificationAction'
import { payTrade } from '../redux/actions/teamTradeAction'
import { IoAlertCircleSharp } from 'react-icons/io5'
import dayjs from 'dayjs'

const LeagueNotification = () => {
  const SETTING = useSelector((state) => state?.user)
  const [date, setDate] = useState(SETTING?.currentDate)
  const [notificationData, setNotificationData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [payId, setPayId] = useState('')
  const [clearBtnLoading, setClearBtnLoading] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    getData()
  }, [date])

  const getData = async () => {
    setIsLoading(true)
    const res = await getAllNotification({
      date: SETTING?.currentDate,
    })
    setNotificationData(res)
    setIsLoading(false)
  }

  const handlePay = async (tradeId) => {
    setPayId(tradeId)
    const res = await payTrade({ tradeId })
    if (res) {
      notification.success({
        message: res,
        duration: 3,
      })
      getData()
    }
    setPayId('')
  }

  const isPayButtonDis = (metadata) => {
    const buyerPaid = metadata?.hasBuyerPaid
    const sellerPaid = metadata?.hasSellerPaid

    const currentTeamId = SETTING?.userDetails?.team?._id

    const buyerTeamId = metadata?.buyer?.team
    const sellerTeamId = metadata?.seller?.team

    if (buyerPaid && currentTeamId === buyerTeamId) {
      return true
    } else if (sellerPaid && currentTeamId === sellerTeamId) {
      return true
    } else {
      return false
    }
  }

  const clearAllNotification = async () => {
    setClearBtnLoading(true)
    const res = await clearNotification()
    if (res) {
      await getData()
    }
    setClearBtnLoading(false)
  }

  const disabledDate = (current) => {
    const currentDay = dayjs(current)
    const minDate = dayjs(leagueStart)
    const maxDate = dayjs(SETTING.currentDate)
    return currentDay.isBefore(minDate) || currentDay.isAfter(maxDate)
  }

  return (
    <div className='practice_squad_container team_trade_main league_notification_container'>
      <MainHeader headingAndDate={false} />
      <div className='date_picker_section' style={{ marginTop: '20px' }}>
        <div className='date_picker_box' style={{ width: '200px' }}>
          <DatePicker
            inputReadOnly={true}
            placeholder='Select Date'
            value={dayjs(date)}
            onChange={(_, dateString) => {
              setDate(dateString)
            }}
            disabledDate={disabledDate}
          />
        </div>
      </div>
      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
        <Button
          loading={clearBtnLoading}
          className='clear_noti_btn'
          type='primary'
          onClick={clearAllNotification}
          disabled={notificationData?.length > 0 ? false : true}
        >
          Clear Notification
        </Button>
      </div> */}

      <div className='league_notification'>
        <header>
          <h3></h3>
        </header>
        <section className='league_standings_body'>
          {isLoading ? (
            <Loader />
          ) : notificationData?.length > 0 ? (
            notificationData?.map((v, i) => {
              return (
                <div key={i} className='card_box'>
                  <div className='header'>
                    <p>{v?.title || 'Untitled'}</p>
                    <span>{v?.alert && <IoAlertCircleSharp size={20} color='red' />}</span>
                  </div>
                  <div className='content'>
                    <p>{v?.message}</p>
                    <h5>Created At: {moment(v?.createdAt).format('ddd DD-MM-YYYY hh:mm a')}</h5>
                    <div className='button_box_approve_reject'>
                      <>
                        {v?.module === 'trade' &&
                          !v?.metadata?.isCancelled &&
                          !v?.metadata?.isApproved && (
                            <>
                              <Button
                                type='primary'
                                className='approve_button'
                                onClick={() => {
                                  navigate('/counter-trade', {
                                    state: {
                                      tradeId: v?.metadata?.tradeId?._id,
                                    },
                                  })
                                }}
                              >
                                View
                              </Button>
                            </>
                          )}

                        {v?.metadata?.isApproved && !v?.metadata?.isCancelled && (
                          <Button
                            disabled={isPayButtonDis(v?.metadata?.tradeId)}
                            loading={payId === v?.metadata?.tradeId?._id}
                            type='primary'
                            className='approve_button'
                            onClick={() => handlePay(v?.metadata?.tradeId?._id)}
                          >
                            {isPayButtonDis(v?.metadata?.tradeId) ? 'Paid' : 'Pay'}
                          </Button>
                        )}
                      </>
                    </div>
                  </div>
                </div>
              )
            })
          ) : (
            <div className='no_notification_box' style={{ height: '200px' }}>
              <p>No Notification...</p>
            </div>
          )}
        </section>
      </div>
    </div>
  )
}

export default LeagueNotification
